export default "/assets/website/images/career_empty_icon.svg?8def96189a740305a7fbd38ea4fd8d29";